/**
 * Processes pasted text for ingredient lists
 * Replaces newlines with commas to format pasted content properly
 * Returns the processed text to be used by the component
 */
export const processIngredientListPaste = (pastedText: string, currentValue: string, selectionStart: number, selectionEnd: number): string => {
  // Replace newlines (both \n and \r\n) with commas
  // Also trim each line and filter out empty strings
  const processedText = pastedText
    .split(/[\r\n]+/)
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .join(', ');
  
  // Create the new value with the processed text inserted at cursor position
  const newValue = currentValue.substring(0, selectionStart) + processedText + currentValue.substring(selectionEnd);
  
  return newValue;
};

